import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";
import jwt_decode from "jwt-decode"; // eslint-disable-line camelcase
import { toast } from "react-toastify";
import axios from "axios";
import setAuthToken from "../../store/utils/setAuthToken";
import { setCurrentUser } from "../../store/actions/authActions";
import Aux from "../../hoc/_Aux/Aux";
import Loading from "../../components/Loading";

class MagicLinkVerify extends Component {
  state = {
    status: "loading", // loading | success | error
    errorMessage: "",
  };

  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get("token");

    if (!token) {
      this.setState({ status: "error", errorMessage: this.props.lang.dictionary.linkInvalid });
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/magic-link/verify`,
        { token }
      );

      // Store JWT and log user in
      localStorage.setItem("jwtToken", data.token);
      setAuthToken(localStorage.jwtToken);
      const decoded = jwt_decode(localStorage.jwtToken);
      this.props.dispatch(setCurrentUser(decoded));

      toast.success("🦄 Welcome to Bailo.app!"); // keep as brand message
      this.setState({ status: "success" });

      // Redirect to dedicated first-time password page
      setTimeout(() => {
        this.props.history.push("/set-first-password");
      }, 1500);
    } catch (err) {
      const msg = err.response?.data?.message || "Invalid or expired link.";
      this.setState({ status: "error", errorMessage: msg });
    }
  }

  render() {
    const { status, errorMessage } = this.state;
    const { dictionary } = this.props.lang;

    return (
      <Aux>
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <div className="card">
              <div className="card-body text-center" style={{ padding: "40px 30px" }}>
                {status === "loading" && (
                  <>
                    <Loading />
                    <p className="text-muted mt-3">{dictionary.verifyingLink}</p>
                  </>
                )}

                {status === "success" && (
                  <>
                    <i className="feather icon-check-circle" style={{ fontSize: 48, color: "#4e6ac5" }} />
                    <h3 className="mt-3 mb-2" style={{ color: "#4e6ac5" }}>{dictionary.accessGranted}</h3>
                    <p className="text-muted">{dictionary.redirectToSetPassword}</p>
                  </>
                )}

                {status === "error" && (
                  <>
                    <i className="feather icon-alert-circle" style={{ fontSize: 48, color: "#e04040" }} />
                    <h3 className="mt-3 mb-2">{dictionary.linkInvalid}</h3>
                    <p className="text-muted mb-4">{errorMessage}</p>
                    <p className="mb-0 text-muted">
                      <NavLink to="/login">{dictionary.backToLogin}</NavLink>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

MagicLinkVerify.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  lang: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(MagicLinkVerify);
